import uat from './env.uat'
import prod from './env.prod'
import new_uat from './new_env.uat'
import new_prod from './new_env.prod'
import configEnvMap from '../config'

let config = {}
if(
  window.location.hostname==='eopen.jdl.com' &&
  configEnvMap[window.location.hostname] &&
  configEnvMap[window.location.hostname].env === 'prod'
){
   config = new_prod
}else if (
   window.location.hostname==='eopen-uat.jdl.com' &&
   configEnvMap[window.location.hostname] &&
   configEnvMap[window.location.hostname].env === 'uat'
 ) {
   config = new_uat
 }else if (
  configEnvMap[window.location.hostname] && 
  configEnvMap[window.location.hostname].env === 'uat'
) {
  config = uat
} else {
  config = prod
}

export default config
